import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestAccessService {
  private API_URL = environment.ACCESS_API_URL;
  constructor(private http: HttpClient) { }

  requestAccess(userEmail: string, reason: string, module: string[], subModule: string[]) {
    const payload = {
      userEmail,
      reason,
      module,
      subModule
    };
    return this.http.post(`${this.API_URL}/sales/realization/request-access`, payload);
  }
}
